export const texts = {
  title: {
    de: 'Auswertung',
    en: 'Analytics'
  },
  notAvailable: {
    de: 'Das Reporting ist nicht verfügbar. Bitte kontaktiere deine Ansprechpartner:in bei skillconomy.',
    en: 'Reporting is not available. Please contact your representative at skillconomy.'
  },
  periodPrefix: {
    de: 'Zeitraum:',
    en: 'Period:'
  },
  monthsSuffix: {
    de: 'Monate',
    en: 'months'
  },
  impact: {
    de: 'Impact',
    en: 'Impact'
  },
  impactBody: {
    de: 'Wie hoch waren die Kosten pro Bewerbung und der ROI im Vergleich zum Benchmark für Inhouse-Active-Sourcing?',
    en: 'How high were the cost per application and the ROI compared to the benchmark for in-house active sourcing?'
  },
  analysisRelease: {
    de: 'Analyse & Freigabe',
    en: 'Analysis & approval'
  },
  analysisReleaseBody: {
    de: 'Wie viele Stellen wurden von der KI analysiert und sind für das Active Sourcing freigegeben worden?',
    en: 'How many positions were analyzed by the AI and approved for active sourcing?'
  },
  analyzedPositions: {
    de: 'Analysierte Stellen',
    en: 'Analyzed positions'
  },
  approvedPositions: {
    de: 'Freigegebene Stellen',
    en: 'Approved positions'
  },
  approvalRate: {
    de: 'Freigabequote',
    en: 'Approval rate'
  },
  visitors: {
    de: 'Besucher',
    en: 'Visitors'
  },
  visitorsBody: {
    de: 'Wie viele der im jeweiligen Monat angesprochenen Kandidat:innen haben sich die Jobsite angeschaut? Wiederkehrende Besucher werden nicht mitgezählt',
    en: 'How many of the candidates contacted in the respective month viewed the jobsite? Returning visitors are not counted.'
  },
  applications: {
    de: 'Bewerbungen',
    en: 'Applications'
  },
  applicationsBody: {
    de: 'Wie viele der im jeweiligen Monat angesprochenen Kandidat:innen haben ihr Interesse an der Stelle geäußert und wurden vorgestellt?',
    en: 'How many of the candidates contacted in the respective month expressed interest in the position and were presented?'
  },
  conversionPerVisitor: {
    de: 'Conversion je Besuchern',
    en: 'Conversion per visitor'
  },
  charts: {
    contacts: {
      de: 'Ansprachen',
      en: 'Outreaches'
    },
    visitors: {
      de: 'Besucher',
      en: 'Visitors'
    },
    applications: {
      de: 'Bewerbungen',
      en: 'Applications'
    },
    approved: {
      de: 'Freigegeben',
      en: 'Approved'
    },
    notApproved: {
      de: 'Nicht freigegeben',
      en: 'Not approved'
    }
  }
};
